import { render, staticRenderFns } from "./social-comment.vue?vue&type=template&id=650e2078&scoped=true&"
import script from "./social-comment.vue?vue&type=script&lang=js&"
export * from "./social-comment.vue?vue&type=script&lang=js&"
import style0 from "./social-comment.vue?vue&type=style&index=0&id=650e2078&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650e2078",
  null
  
)

export default component.exports